import './base'
import { DonateForm } from '../donate'
import { createElement } from 'react'
import { renderWithLocale } from 'shared'
import type { Config } from 'donate/types'

document.addEventListener('DOMContentLoaded', () => {
  if (window.parent) window.parent.postMessage('bpIframeLoadStart', '*')

  const MountDonateForm = document.getElementById('mount-donate-form')
  if (MountDonateForm) {
    const config: Config = JSON.parse(MountDonateForm.getAttribute('data-config') ?? `{}`)
    const display = JSON.parse(MountDonateForm.getAttribute('data-display') ?? `{}`)
    config.receiverId = String(config.receiverId)
    const form = createElement(DonateForm, { config, display })
    renderWithLocale(form, MountDonateForm)
  }
})
